
        var result = require("!!../../../node_modules/css-loader/index.js!./submenu-item.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/menu/submenu-item.component.css
// module id = 2141
// module chunks = 1